module.exports = __webpack_public_path__ + "img/test2.51ddf8df.png";